enum OrderStatus {
    New = "New", // appena ricevuto
    SentToERP = "SentToERP", // inviato a M3
    ReadyForPicking = "ReadyForPicking", // Pronto per la spedizione
    ShippingInProgress = "ShippingInProgress", // spedizione-lavorazione in corso
    ShippingCompleted = "ShippingCompleted", // tutto spedito
    Cancelled = "Cancelled", // cancellato
    ShippedAndInvoiced = "ShippedAndInvoiced" // spedito e fatturato, cioè chiuso
}

export default OrderStatus;